import React, { FC } from 'react';
import { ClosedPositionItem } from '../../ClosedPositionsModel';
import { DataTable, ColumnConfig } from '../../../DataTable';

interface Props {
  rows: ClosedPositionItem[];
  translation: any;
  columns: ColumnConfig<ClosedPositionItem>[];
  selectedColumns: string[];
  onSelectColumns: (cols: string[]) => void;
}

export const ReportTable: FC<Props> = ({ rows, translation, columns, selectedColumns, onSelectColumns }) => (
  <DataTable columns={columns} data={rows} translation={translation} columnSelect selectedColumns={selectedColumns} onSelectColumns={onSelectColumns} emptyMessage={translation.reports_EmptyTableMessage} />
);
